export const pricingPlansSeedData = [
    {
        // Existing fields
        name: "Prime",
        price: 20000,
        priceDetails: "per annum",
        period: "(Taxes Extra)",
        features: [
            "Validity - 1 Year | Quarterly Renewal",
            "Intro Plan",
            "Upto 2 Stocks per Quarter",
            "1 Multi-Bagger Recommendation",
            "Small Cap"
        ],
        recommended: false,
        inactive: false,
        order: 1,
        riskLevel: 1,
        
        // New structured fields for multiple plans support
        maxStocksPerQuarter: 2,
        planType: "intro",
        description: "Perfect starting point for new investors with basic equity exposure",
        validityMonths: 12,
        renewalType: "quarterly",
        capTypes: ["small"],
        multiBaggerCount: 1,
        canViewCharts: false,
        canViewReports: true,
        
        // Metadata
        createdAt: new Date(),
        updatedAt: new Date()
    },
    {
        // Existing fields
        name: "Prime+",
        price: 25000,
        priceDetails: "per annum",
        period: "(Taxes Extra)",
        features: [
            "Validity - 1 Year | Quarterly Renewal",
            "Core Equity Plan",
            "Upto 2 Stocks per Quarter",
            "1 Multi-Bagger Recommendation",
            "Small Cap"
        ],
        recommended: false,
        inactive: false,
        order: 2,
        riskLevel: 2,
        
        // New structured fields for multiple plans support
        maxStocksPerQuarter: 2,
        planType: "core",
        description: "Enhanced equity exposure with better risk management",
        validityMonths: 12,
        renewalType: "quarterly",
        capTypes: ["small"],
        multiBaggerCount: 1,
        canViewCharts: false,
        canViewReports: true,
        
        // Metadata
        createdAt: new Date(),
        updatedAt: new Date()
    },
    {
        // Existing fields
        name: "Elite",
        price: 40000,
        priceDetails: "per annum",
        period: "(Taxes Extra)",
        features: [
            "Validity - 1 Year | Quarterly Renewal",
            "Near-Term Growth Strategy",
            "Upto 3 Stocks per Quarter",
            "1 Multi-Bagger Recommendation",
            "Small & Mid Cap"
        ],
        recommended: true,
        inactive: false,
        order: 3,
        riskLevel: 3,
        
        // New structured fields for multiple plans support
        maxStocksPerQuarter: 3,
        planType: "growth",
        description: "Balanced growth strategy with small and mid-cap exposure",
        validityMonths: 12,
        renewalType: "quarterly",
        capTypes: ["small", "mid"],
        multiBaggerCount: 1,
        canViewCharts: true,
        canViewReports: true,
        
        // Metadata
        createdAt: new Date(),
        updatedAt: new Date()
    },
    {
        // Existing fields
        name: "Elite+",
        price: 50000,
        priceDetails: "per annum",
        period: "(Taxes Extra)",
        features: [
            "Validity - 1 Year | Quarterly Renewal",
            "Tactical Allocation Strategy",
            "Upto 3 Stocks per Quarter",
            "1 Multi-Bagger Recommendation",
            "Small & Mid Cap"
        ],
        recommended: false,
        inactive: false,
        order: 4,
        riskLevel: 4,
        
        // New structured fields for multiple plans support
        maxStocksPerQuarter: 3,
        planType: "tactical",
        description: "Advanced tactical allocation with enhanced market timing",
        validityMonths: 12,
        renewalType: "quarterly",
        capTypes: ["small", "mid"],
        multiBaggerCount: 1,
        canViewCharts: true,
        canViewReports: true,
        
        // Metadata
        createdAt: new Date(),
        updatedAt: new Date()
    },
    {
        // Existing fields
        name: "Supreme",
        price: 90000,
        priceDetails: "per annum",
        period: "(Taxes Extra)",
        features: [
            "Validity - 1 Year | Quarterly Renewal",
            "Focused Equity & ETF Blend",
            "Upto 4 Stocks per Quarter",
            "1 Multi-Bagger Recommendation",
            "Small, Mid & Large Cap"
        ],
        recommended: false,
        inactive: false,
        order: 5,
        riskLevel: 5,
        
        // New structured fields for multiple plans support
        maxStocksPerQuarter: 4,
        planType: "premium",
        description: "Comprehensive equity and ETF strategy with full market exposure",
        validityMonths: 12,
        renewalType: "quarterly",
        capTypes: ["small", "mid", "large"],
        multiBaggerCount: 1,
        canViewCharts: true,
        canViewReports: true,
        
        // Metadata
        createdAt: new Date(),
        updatedAt: new Date()
    },
    {
        // Existing fields
        name: "Supreme+",
        price: 120000,
        priceDetails: "per annum",
        period: "(Taxes Extra)",
        features: [
            "Validity - 1 Year | Quarterly Renewal",
            "Diversified Equity + ETF Strategy",
            "Upto 4 Stocks per Quarter",
            "1 Multi-Bagger Recommendation",
            "Small, Mid & Large Cap"
        ],
        recommended: false,
        inactive: false,
        order: 6,
        riskLevel: 5,
        
        // New structured fields for multiple plans support
        maxStocksPerQuarter: 4,
        planType: "ultimate",
        description: "Ultimate diversified strategy with maximum market coverage",
        validityMonths: 12,
        renewalType: "quarterly",
        capTypes: ["small", "mid", "large"],
        multiBaggerCount: 1,
        canViewCharts: true,
        canViewReports: true,
        
        // Metadata
        createdAt: new Date(),
        updatedAt: new Date()
    }
]; 